// Swipe behaviour for the USP bar.
//
// Swiper handles the drag itself, so the track follows the finger. This adds two things
// on top: the autoplay timer is restarted after a manual swipe, and a gesture that lands
// more than one slide away is pulled back.
//
// Plain defer script, not the importmap, since it has no theme imports.

(function () {
  "use strict";

  var BOUND_FLAG = "uspSwipeBound";
  var LISTENERS_FLAG = "uspSwipeListeners";

  function realSlideCount(slider) {
    // Counted from the DOM, excluding any loop clones, so the maths does not depend on
    // whether this Swiper build duplicates slides to create the loop.
    return slider.querySelectorAll(".usp-bar__slide:not(.swiper-slide-duplicate)").length;
  }

  function restartAutoplay(swiper) {
    // Resuming keeps whatever time was left on the clock, which can be near zero - that
    // fires a second advance immediately after the manual one. A stop/start gives a
    // full fresh interval.
    if (!swiper.autoplay || !swiper.autoplay.running) return;
    swiper.autoplay.stop();
    swiper.autoplay.start();
  }

  function clamp(slider, swiper, fromIndex) {
    if (swiper.realIndex === fromIndex) return;

    var total = realSlideCount(slider);
    if (total < 2) return;

    // Direction from Swiper's own reading of the drag, which already accounts for RTL.
    // An index delta cannot be used: on a loop of three, two forward is arithmetically
    // one back, so an overshoot is indistinguishable from a legal step.
    var step = swiper.swipeDirection === "prev" ? -1 : 1;
    var expected = (((fromIndex + step) % total) + total) % total;

    if (swiper.realIndex === expected) return;

    if (swiper.params.loop) {
      swiper.slideToLoop(expected);
    } else {
      swiper.slideTo(expected);
    }
  }

  // Bound to the Swiper instance rather than the DOM: Swiper may capture the pointer
  // mid-drag, so its own touchStart/touchEnd are the dependable signals.
  function bindInstance(slider) {
    var swiper = slider.swiperInstance;
    if (!swiper || swiper.destroyed || swiper[BOUND_FLAG]) return;
    swiper[BOUND_FLAG] = true;

    var fromIndex = null;

    swiper.on("touchStart", function () {
      fromIndex = swiper.realIndex;
    });

    swiper.on("touchEnd", function () {
      var start = fromIndex;
      fromIndex = null;
      restartAutoplay(swiper);
      if (start === null) return;

      // Swiper picks its snap in the same handler, so the correction waits a frame.
      // rAF runs before the next paint, so no frame of the wrong move is drawn.
      requestAnimationFrame(function () {
        if (slider.swiperInstance !== swiper || swiper.destroyed) return;
        clamp(slider, swiper, start);
      });
    });
  }

  function attach(slider) {
    if (slider[LISTENERS_FLAG]) {
      bindInstance(slider);
      return;
    }
    slider[LISTENERS_FLAG] = true;

    // destroyAbove tears the instance down past 768px and builds a new one on the way
    // back, so binding is re-checked at the start of every gesture rather than once.
    var rebind = function () {
      bindInstance(slider);
    };

    slider.addEventListener("pointerdown", rebind, { passive: true });
    slider.addEventListener("touchstart", rebind, { passive: true });
    bindInstance(slider);
  }

  function init() {
    var sliders = document.querySelectorAll(".usp-bar__wrapper");
    for (var i = 0; i < sliders.length; i++) attach(sliders[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Section re-renders in the theme editor replace the element, so rebind on reload.
  document.addEventListener("shopify:section:load", init);
})();
